import { Injectable } from '@angular/core';
import { MediaHavenPlugin } from '../entities/mediahaven-plugins.entity';
import { PluginGuard } from './plugin.guard';

@Injectable({
    providedIn: 'root'
})
export class SemanticSearchGuard extends PluginGuard {
    protected PLUGINS_TO_CHECK: MediaHavenPlugin[] = [MediaHavenPlugin.SEMANTIC_SEARCH];
}
